// extracted by mini-css-extract-plugin
export default {"container":"Loader_container__Eyvfz","fullPage":"Loader_fullPage__GIO9Z"};